import { z } from 'zod';
import { IdSchema, PaginationQuerySchema, paginatedSchema } from './common';

export const WarehouseSchema = z.object({
  id: IdSchema,
  code: z.string(),
  name: z.string(),
  address: z.string().nullable(),
  /** Exactly one warehouse per tenant is the default receiving location. */
  isDefault: z.boolean(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Warehouse = z.infer<typeof WarehouseSchema>;

export const WarehouseListSchema = paginatedSchema(WarehouseSchema);

export const CreateWarehouseSchema = z.object({
  code: z.string().trim().min(1).max(32),
  name: z.string().trim().min(1).max(200),
  address: z.string().trim().max(500).nullable().optional(),
  isDefault: z.boolean().default(false),
  isActive: z.boolean().default(true),
});
export type CreateWarehouse = z.infer<typeof CreateWarehouseSchema>;

export const UpdateWarehouseSchema = CreateWarehouseSchema.partial();
export type UpdateWarehouse = z.infer<typeof UpdateWarehouseSchema>;

export const WarehouseQuerySchema = PaginationQuerySchema.extend({
  isActive: z.coerce.boolean().optional(),
});
export type WarehouseQuery = z.infer<typeof WarehouseQuerySchema>;
export type WarehouseQueryInput = z.input<typeof WarehouseQuerySchema>;
